<template>
  <div v-if="isShowLoading">
    <DDLoading />
  </div>
  <div class="main-container disablecopy" v-else-if="isHasInfo">
    <div class="main-pic-container">
      <DDMainpic :skuImg="productInfo.skuImage" />
      <div class="main-skuname">
        {{ productInfo.skuName }}
      </div>
    </div>
    <div class="main-qrcode-container">
      <div class="qrcode-title">
        <TitleLine />
      </div>
      <div class="qrcode-list">
        <!-- 区分单个元素还是多个 -->
        <div v-if="productInfo.traces.length === 1" class="traces-single">
          <!-- 单行居中布局 -->
          <QrcodeBox
            :qrcodeInfo="{
              url: productInfo.traces[0].qrUrl,
              desc: '批次: ' + productInfo.traces[0].lotNo
            }"
          />
        </div>
        <div v-else class="traces-columns">
          <div class="grid-box" v-for="v in productInfo.traces" :key="v.lotNo">
            <QrcodeBox
              :qrcodeInfo="{
                url: v.qrUrl,
                desc: '批次: ' + v.lotNo
              }"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="main-footer">
      <img
        class="footer-img"
        src="../assets/img-bottom@1x.png"
        alt="叮咚买菜"
        srcset="../assets/img-bottom@2x.png"
      />
    </div>
  </div>
  <div v-else>
    <DDLost :errorType="'error'" />
  </div>
</template>

<script>
import http from "@/utils/request.js";
import DDLoading from "@/components/Loading.vue";
import DDMainpic from "@/components/Mainpic.vue";
import TitleLine from "@/components/TitleLine.vue";
import QrcodeBox from "@/components/QrcodeBox.vue";
import DDLost from "@/views/Lost.vue";
import ModuleServiceUrl from "@/utils/moduleServiceUrl";
export default {
  data() {
    return {
      productInfo: {
        skuId: null,
        skuName: "",
        skuImage: "",
        traces: []
      },
      productId: null,
      stationId: null,
      isShowLoading: true, // 显示loading
      isHasInfo: true // 判断是否有查到数据,如果没有的话显示 溯源信息迷路了…
    };
  },

  async created() {
    await ModuleServiceUrl.judgeCtsServiceUrl();
    // 解析url   http://trace.te.test.srv.mc.dd/#/productTrackInfo?product_id=9742&station_id=1194&title=叮咚食品安全溯源
    // const tempUrl = `http://localhost:8080/#/productTrackInfo?product_id=9742&station_id=1194&title=叮咚食品安全溯源`;
    const tempUrl = location.href;
    const { productId, stationId, title } = this.parseUrlHash(tempUrl);
    document.title = decodeURIComponent(title) || "叮咚买菜商品溯源";
    // 获取数据
    const url = `${ModuleServiceUrl.getCtsUrl()}/api/v1/produceTrace/tj/query`;
    const params = { productId, stationId };
    const result = await http.get(`${url}`, { params });
    if (result.success) {
      this.isShowLoading = false;
      const {
        skuId = "",
        skuName = "",
        skuImage = "",
        traces = []
      } = result.data;
      if (!skuId) {
        this.isHasInfo = false;
        return;
      }
      this.productInfo = { skuId, skuName, skuImage, traces };
    }
  },
  components: {
    DDLoading,
    DDMainpic,
    TitleLine,
    QrcodeBox,
    DDLost
  },
  methods: {
    parseUrlHash(url) {
      const _temp = url.substr(url.indexOf("?") + 1);
      const arrParam = _temp.split("&");
      let _productId;
      let _stationId;
      let _title = "";
      arrParam.forEach(v => {
        const _tempV = v;
        const _tempArr = _tempV.split("=");
        if (_tempArr[0] == "product_id") {
          _productId = _tempArr[1];
        }
        if (_tempArr[0] == "station_id") {
          _stationId = _tempArr[1];
        }
        if (_tempArr[0] == "title") {
          _title = _tempArr[1];
        }
      });
      return {
        productId: _productId,
        stationId: _stationId,
        title: _title
      };
    }
  }
};
</script>

<style lang="less">
.main-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.disablecopy {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  user-select: none;
}

.main-skuname {
  background-color: white;
  height: 52.5px;
  line-height: 52.5px;
  font-size: 16px;
  color: #333;
  padding-left: 16px;
}
.main-qrcode-container {
  flex: 1;
  margin-top: 10px;
  background-color: #fff;
  padding-top: 12.5px;
}
.qrcode-list {
  padding: 49px 30px 73px 30px;
  .traces-single {
    display: flex;
    justify-content: center;
  }
  .traces-columns {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.main-footer {
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-img {
  width: 110px;
  height: auto;
}
</style>
